// extracted by mini-css-extract-plugin
export default {"wrapper":"AFITrendArrow_wrapper__LcG0G","arrow":"AFITrendArrow_arrow__FxEdc","delta":"AFITrendArrow_delta__qiBEs"};